module.exports = __webpack_public_path__ + "media/stylesheets/fonts/fontawesome/fa-solid-900-7a5de9b08012e4da40504f2cf126a351.svg";